<template>
  <el-dialog
    top="15vh"
    class="recipeType-edit__dialog"
    :title="$t('System.partPurchaseSet')"
    width="800px"
    :close-on-click-modal="false"
    :before-close="close"
    :visible.sync="visible"
  >
    <!--    v-model="content"-->
    <QuillEdit
      v-if="visible"
      ref="myQuillEditor"
      :content="content"
      @blur="onEditorBlur($event)"
      @focus="onEditorFocus($event)"
      @change="onEditorChange($event)"
    >
    </QuillEdit>

    <div slot="footer" class="edit-footer">
      <hl-button type="border" @click="close">{{ $t('Common.cancel') }}</hl-button>
      <hl-button @click="save" :loading="loading">{{ $t('Common.save') }}</hl-button>
    </div>
  </el-dialog>
</template>

<script>
import HlButton from '../../../components/Button'
import { uploadFile } from '@/utils/utils'
import { languageList } from '@/config/status.js'
import QuillEdit from '@/components/QuillEditor'
export default {
  components: {
    HlButton,
    QuillEdit
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    row: {
      type: Object
    }
  },

  data() {
    return {
      languageList,
      typeNames: [{}],
      form: {},
      // rules: {
      //   code: [{ required: true, message: '请输入菜谱分类编码', trigger: 'blur' }],
      //   iconFileId: [{ required: true, message: '请选择菜谱分类图片', trigger: ['change', 'blur'] }]
      // },
      loading: false,
      clickActionOpions: [],
      pushUserOptions: [],
      content: ''
    }
  },
  created() {
    if (this.row.language) {
      let params = {
        language: this.row.language
      }
      this.$ajax
        .get(this.$api.system.detail_part_purchase, params)
        .then((res) => {
          this.content = res.data
        })
        .catch(() => {})
    }
  },
  methods: {
    onEditorReady(editor) {
      // 准备编辑器
    },
    onEditorBlur() {}, // 失去焦点事件
    onEditorFocus() {}, // 获得焦点事件
    onEditorChange() {}, // 内容改变事件
    escapeStringHTML(str) {
      str = str.replace(/&lt;/g, '<')
      str = str.replace(/&gt;/g, '>')
      return str
    },

    async pickImg(file) {
      if (file) {
        await uploadFile(file)
          .then((res) => {
            this.$set(this.form, 'iconFileId', res.data)
            // this.form.iconFileId = res.data
            // console.log('')
          })
          .catch(() => {})
      } else {
        this.form.iconFileId = ''
      }
    },
    // 添加语言
    addLang() {
      this.typeNames.push({})
    },
    // 删除语言
    deleteLang(index) {
      this.typeNames.splice(index, 1)
    },
    close() {
      this.$emit('update:visible', false)
    },
    // checkForm() {
    //   let pass
    //   pass = this.typeNames.every((el) => {
    //     return el.language && el.name
    //   })
    //   if (!pass) {
    //     this.$message.warning('请完善菜谱分类信息')
    //     return false
    //   }
    //   this.$refs.form.validate((valid) => {
    //     pass = valid
    //   })
    //   return pass
    // },
    save() {
      console.log(this.$refs.myQuillEditor.detailContent)
      if (this.row.language) {
        const params = {
          language: this.row.language,
          content: this.$refs.myQuillEditor.detailContent
        }
        const config = {
          headers: {
            'Content-Type': 'application/json'
          }
        }
        this.$ajax
          .post(this.$api.system.save_part_purchase, params, config)
          .then(() => {
            this.$message.success(`${this.$t('Common.saveSuccess')}`)
            this.close()
            this.$emit('refresh')
          })
          .catch(() => {})
          .finally(() => {
            this.loading = false
          })
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.recipeType-edit__dialog {
  /deep/.el-dialog__body {
    padding: 24px;
  }
  .iconDiv {
    width: 24px;
    height: 24px;
    cursor: pointer;
    border-radius: 4px;
    text-align: center;
    &:hover {
      background-color: rgba(32, 70, 199, 0.2);
    }
    &:active {
      background-color: rgba(32, 70, 199, 0.3);
    }
  }
  /deep/ .speInput {
    width: 310px !important;
    .el-input.el-input--small.el-input--suffix {
      width: 200px !important;
    }
  }
  .tableDiv {
    background: #eff4fc;
    padding: 4px 16px 16px 16px;
    border-radius: 8px;
  }
  /deep/ .speTab {
    tr {
      background: #eff4fc !important;
    }
  }
  .add-bt {
    margin-top: 8px;
    width: 100%;
    background: #ffffff;
    border: 2px dashed #dcdfe6;
    border-radius: 4px;
    text-align: center;
    cursor: pointer;
    span {
      color: #2046c7;
    }
    &:hover {
      background: #eff4fc;
      border-radius: 4px;
      border: 2px dashed #dadfe6;
    }
    &:active {
      background: #e3e8f0;
      border-radius: 4px;
      border: 2px solid #dadfe6;
    }
  }
}
</style>
